'use client';

import Link from 'next/link';
import { memo, useEffect, useState } from 'react';

import { ShopifyAdminRoutes } from '~/constants/Routes';

export const NoProductState = memo(() => {
  const [storeName, setStoreName] = useState<string | null>(null);

  useEffect(() => {
    const shop = window.shopify?.config?.shop;

    if (shop) {
      setStoreName(shop.replace('.myshopify.com', ''));
    }
  }, []);

  const productsUrl = storeName ? ShopifyAdminRoutes.products(storeName) : null;
  const newProductUrl = storeName ? ShopifyAdminRoutes.newProduct(storeName) : null;

  return (
    <main className="flex min-h-screen flex-col items-center bg-gray-2 px-6 py-8">
      <div className="w-full max-w-2xl">
        <div className="rounded-16 border border-gray-4 bg-white dark:bg-gray-1">
          <div className="mx-3 mt-3 overflow-hidden rounded-12">
            {/* biome-ignore lint/performance/noImgElement: local static asset, imgix loader doesn't support relative paths */}
            <img alt="Air" className="h-48 w-full object-cover" src="/air-hero.png" />
          </div>
          <div className="p-6">
            <h1 className="mb-1 font-semibold text-14 text-gray-12">Use Air assets on your products</h1>
            <p className="mb-4 text-14 text-gray-11">
              Add images and videos from Air to your Shopify products in a few quick steps
            </p>
            <ol className="flex list-inside list-decimal flex-col gap-2">
              <li className="rounded-8 bg-gray-2 px-4 py-3 text-14 text-gray-12">
                {newProductUrl ? (
                  <Link className="underline" href={newProductUrl} target="_top">
                    Add
                  </Link>
                ) : (
                  <span className="underline">Add</span>
                )}{' '}
                or{' '}
                {productsUrl ? (
                  <Link className="underline" href={productsUrl} target="_top">
                    open
                  </Link>
                ) : (
                  <span className="underline">open</span>
                )}{' '}
                a product
              </li>
              <li className="rounded-8 bg-gray-2 px-4 py-3 text-14 text-gray-12">
                Click More actions to select Air - Add product images/videos
              </li>
              <li className="rounded-8 bg-gray-2 px-4 py-3 text-14 text-gray-12">Pick images or videos from Air</li>
              <li className="rounded-8 bg-gray-2 px-4 py-3 text-14 text-gray-12">
                Upload them directly to your product!
              </li>
            </ol>
          </div>
        </div>

        <div className="mt-6 flex flex-col gap-2 px-1">
          <p className="font-semibold text-14 text-gray-12">Tips!</p>
          <ul className="list-disc pl-5 text-14 text-gray-11">
            <li>Shopify hosts your media. If you update an asset in Air, upload it again to update it in Shopify</li>
            <li>
              This plugin is available for Air users on an Enterprise plan.{' '}
              <Link className="underline" href="https://air.inc/pricing" rel="noopener noreferrer" target="_blank">
                Learn more about Air plans
              </Link>
              .
            </li>
          </ul>
        </div>
      </div>
    </main>
  );
});

NoProductState.displayName = 'NoProductState';
